import {subclass, property} from "@arcgis/core/core/accessorSupport/decorators";

import Widget from "@arcgis/core/widgets/Widget";

import { messageBundle, tsx } from "@arcgis/core/widgets/support/widget";

import AppT9N from "../../../t9n/App/App.json";
import "./MyAppsSidebar.scss";
import NavBarViewModel from "../../ui/NavBar/NavBarViewModel";
import {EAppTemplateType} from "templates-common-library/baseClasses/CompatibilityChecker";
import {VNode} from "../../../interfaces/interfaces";

@subclass("app.widgets.Sidebar.MyAppsSidebar")
export default class MyAppsSidebar extends (Widget) {

  //--------------------------------------------------------------------------
  //
  //  Properties
  //
  //--------------------------------------------------------------------------
  
  @property()
  navbarVM: NavBarViewModel;

  @property()
  @messageBundle("dist/assets/t9n/App/App")
  appMessages: typeof AppT9N;

  //--------------------------------------------------------------------------
  //
  //  Public Methods
  //
  //--------------------------------------------------------------------------

  constructor(args){
    super(args);
  }

  render() {
    const { 
      choose, chooseInfo, copy, copyInfo,
      configure, configureInfo, appStudioInfo,
      ownerHeader, myApps, myOrgApps,
      templateHeader, templates,
      shareHeader, owner, organization, publicLabel
    } = this.appMessages.myAppsTabSidebar;

    const { isPublicAcct } = this.navbarVM.myAppsDataVM;

    return (
      <div class="myapps-sidebar">

      {!isPublicAcct && 
        <div class="filter-section">
            <div class="filter-header">
              <h4>{ownerHeader}</h4>
            </div>
            
            <calcite-tree onCalciteTreeSelect={this._handleMyContentFilter.bind(this)}>
              <calcite-tree-item 
                id="myApps" 
                selected={this.navbarVM.myAppsDataVM.contentLevel === "myApps"}>
                {myApps}
              </calcite-tree-item>
              <calcite-tree-item
                id="orgApps" 
                selected={this.navbarVM.myAppsDataVM.contentLevel === "orgApps"}>
                  {myOrgApps}
              </calcite-tree-item> 
            </calcite-tree>
          </div>
        }

        <div class="filter-section">
          <div class="filter-header">
            <h4>{templateHeader}</h4>
            { this._renderClearBtn("template") }
          </div>

          <calcite-tree selection-mode="multi"
            onCalciteTreeSelect={this._handleTemplateFilter.bind(this)}
          >
              {
                Object.values(EAppTemplateType).map((templateValue)=>{
                  return (
                    <calcite-tree-item id={templateValue} 
                      selected={
                        this?.navbarVM?.myAppsDataVM?.templatesFilter != null 
                        && this?.navbarVM?.myAppsDataVM?.templatesFilter?.findIndex((templateFilter)=>{ 
                          return templateFilter === templateValue 
                        }) !== -1
                    }>
                      { templates?.[templateValue] }
                    </calcite-tree-item>
                  );
                })
              }
          </calcite-tree>
        </div>

        <div class="filter-section">
          <div class="filter-header">
            <h4>{ shareHeader }</h4>
            { this._renderClearBtn("sharing") }
          </div>

          <calcite-tree
            onCalciteTreeSelect={this._handleSharingFilter.bind(this)}
          >
              <calcite-tree-item 
                id="owner" 
                selected={this.navbarVM.myAppsDataVM.sharingLevel === "owner"}>
                  { owner }
              </calcite-tree-item>
              {!isPublicAcct && <calcite-tree-item 
                id="org" 
                selected={this.navbarVM.myAppsDataVM.sharingLevel === "org"}>
                  { organization }
              </calcite-tree-item> }
              <calcite-tree-item 
                id="public" 
                selected={this.navbarVM.myAppsDataVM.sharingLevel === "public"}>
                  { publicLabel }
              </calcite-tree-item>
          </calcite-tree>
        </div>

      </div>
      );
  }

  //--------------------------------------------------------------------------
  //
  //  Private Methods
  //
  //--------------------------------------------------------------------------
  private _renderClearBtn(filterType: "owner" | "template" | "sharing"): VNode {
    const { 
      contentLevel, 
      templatesFilter, 
      sharingLevel 
    } = this.navbarVM.myAppsDataVM;

    const shouldHide = filterType === "owner" 
      ? "myApps" === contentLevel
      : filterType === "template"
        ? templatesFilter?.length === 0 || templatesFilter == null
        : filterType === "sharing"
          ? null == sharingLevel
          : null;
    return (
      shouldHide ? null : (<calcite-button 
        appearance="clear"
        icon-start="x"
        onclick={(e)=>{
          switch(filterType){
            case "owner":
              this._handleMyContentFilter(null, "myApps");
              return;
            case "template":
              this._handleTemplateFilter(null, []);
              return;
            case "sharing":
              this._handleSharingFilter(null, null);
              return;
          }
        }}
        title={this?.appMessages?.myApps?.delete?.clear}
      >
      </calcite-button>)
    )
  }

  private _handleMyContentFilter(e: any, override?: any){
    this.navbarVM.myAppsDataVM.setContentLevelAndRequery(
      override ?? e?.detail?.selected?.[0]?.id
    );
  }

  private _handleTemplateFilter(e: any, override?: any){
    this.navbarVM.myAppsDataVM.setTemplatesFilterAndRequery(
      override ?? e?.detail?.selected?.map(option=>option.id)
    )
  }

  private _handleSharingFilter(e: any, override?: any){
    this.navbarVM.myAppsDataVM.setSharingLevelAndRequery(
      override ?? e?.detail?.selected?.[0]?.id
    );
  }

}